import { actionTypes } from '..'

export const set = (scroll) => (dispatch) => {
  dispatch({
    type: actionTypes.SET_SCROLL,
    payload: scroll
 })
}
